import i18n from '../../../i18n'

export function toTaskPrioritySelectItem(item) {
  return {
    archived: item.deleted,
    label: item.is_persistent ? i18n.t(item.value) : item.value,
    labelBackgroundColor: 'var(--secondary-text-color-10)',
    labelTextColor: 'var(--main-text-color)',
    value: item.id,
  }
}

export function toTaskPrioritySelectItems(data) {
  return data.map(toTaskPrioritySelectItem)
}
